import type { App, Plugin } from 'vue';

export interface ApplicationConfig {
  FRONTEND_BASEURL: string;
  BACKEND_BASEURL: string;
  VERSION_IDENTIFIER: string;
}

/**
 * Default configuration values
 */
const _appconfig: ApplicationConfig = {
  FRONTEND_BASEURL: "http://localhost:8080",
  BACKEND_BASEURL:  "http://localhost:9000",
  VERSION_IDENTIFIER: "00.1000",
};

// Load environment variables
const VITE_FRONTEND_BASEURL = import.meta.env.VITE_FRONTEND_BASEURL;
const VITE_BACKEND_BASEURL = import.meta.env.VITE_BACKEND_BASEURL;
const VITE_VERSION_IDENTIFIER = import.meta.env.VITE_VERSION_IDENTIFIER;

// Override with environment variables if available
if(VITE_FRONTEND_BASEURL)
  _appconfig.FRONTEND_BASEURL = VITE_FRONTEND_BASEURL as string;

if(VITE_BACKEND_BASEURL)
  _appconfig.BACKEND_BASEURL = VITE_BACKEND_BASEURL as string;

if(VITE_VERSION_IDENTIFIER)
  _appconfig.VERSION_IDENTIFIER = VITE_VERSION_IDENTIFIER as string;

// Ensure URLs end with trailing slash
if(!_appconfig.FRONTEND_BASEURL.endsWith('/'))
  _appconfig.FRONTEND_BASEURL += '/';

if(!_appconfig.BACKEND_BASEURL.endsWith('/'))
  _appconfig.BACKEND_BASEURL += '/';

/**
 * Vue plugin that provides application configuration
 */
const configProvider: Plugin = {
  install: (app: App) => {
    app.config.globalProperties.$appconfig = _appconfig;
  }
};

export default configProvider;
